export const getInitialStudentInfo = (searchParams, defaults = {}) => {
  // searchParams can be a URLSearchParams object, location.search string, or URLSearchParams instance
  const params = typeof searchParams === 'string' 
    ? new URLSearchParams(searchParams) 
    : (searchParams instanceof URLSearchParams ? searchParams : new URLSearchParams());

  // Query-параметри мають найвищий пріоритет
  const nameParam = params.get('name') || params.get('studentName') || params.get('firstName') || params.get('fname') || '';
  let firstName = nameParam;
  let lastName = params.get('lastName') || params.get('studentLastName') || params.get('surname') || params.get('lname') || '';
  
  // Зберігаємо webhookUrl або callbackUrl в sessionStorage
  const webhookUrl = params.get('webhookUrl') || params.get('callbackUrl') || '';
  if (webhookUrl) {
    try {
      sessionStorage.setItem('serviq_webhook_url', webhookUrl);
    } catch (err) {
      console.error('Error saving webhookUrl to sessionStorage:', err);
    }
  }

  // Зберігаємо externalId або externalUserId в sessionStorage
  const externalId = params.get('externalId') || params.get('externalUserId') || params.get('userId') || '';
  if (externalId) {
    try {
      sessionStorage.setItem('serviq_external_id', externalId);
    } catch (err) {
      console.error('Error saving externalId to sessionStorage:', err);
    }
  }

  // Спробуємо завантажити дані авторизованого користувача з localStorage як запасний варіант
  let defaultFirstName = '';
  let defaultLastName = '';
  let defaultCity = '';
  let defaultPosition = '';
  
  try {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      const user = JSON.parse(savedUser);
      if (user.role === 'student' || user.studentName) {
        defaultFirstName = user.studentName || '';
        defaultLastName = user.studentLastName || '';
        defaultCity = user.studentCity || user.city || '';
        defaultPosition = user.position || 'waiter';
      }
    }
  } catch (err) {
    console.error('Error parsing saved user for prefill:', err);
  }

  // Якщо nameParam містить пробіл і lastName не вказано окремо, розділяємо ім'я та прізвище
  if (nameParam && !lastName) {
    const parts = nameParam.trim().split(/\s+/);
    if (parts.length > 1) {
      firstName = parts[0];
      lastName = parts.slice(1).join(' ');
    }
  }

  const city = params.get('city') || params.get('studentCity') || '';
  const position = params.get('position') || params.get('studentPosition') || '';

  return {
    firstName: firstName || defaults.firstName || defaultFirstName,
    lastName: lastName || defaults.lastName || defaultLastName,
    city: city || defaults.city || defaultCity,
    position: position || defaults.position || defaultPosition,
    externalId: externalId || sessionStorage.getItem('serviq_external_id') || ''
  };
};

export const checkAutoRegister = (info, cityBindingEnabled) => {
  if (!info.firstName || !info.lastName || !info.position) {
    return false;
  }
  if (!cityBindingEnabled && !info.city) {
    return false;
  }
  return true;
};
